import {type Control, Controller, type FieldPath, type FieldValues, type Path, type PathValue} from 'react-hook-form';
import type {ReactElement} from 'react';
import {FormControl, InputLabel, Select, type SelectProps as BaseProps, Typography} from '@mui/material';

export type ControlledFieldProps<T extends FieldValues> = {
    control: Control<T>;
    name: FieldPath<T>;
    defaultValue?: PathValue<T, Path<T> & string> | undefined;
    items: (ReactElement | null)[];
} & Omit<BaseProps, 'defaultValue'>;

export function SelectInputForm<T extends FieldValues>({
                                                           control,
                                                           onBlur,
                                                           sx,
                                                           onChange,
                                                           defaultValue,
                                                           items,
                                                           name,
                                                           margin,
                                                           fullWidth,
                                                           ...props
                                                       }: ControlledFieldProps<T>) {

    return (
        <FormControl
            margin={margin ?? 'none'}
            fullWidth={fullWidth ?? true}
        >
            <InputLabel>
                {props.label}
            </InputLabel>
            <Controller
                defaultValue={
                    defaultValue ?? ('' as PathValue<T, Path<T> & string>)
                }
                control={control}
                name={name}
                render={({
                             field: {
                                 onChange: fieldOnChange,
                                 value,
                                 onBlur: fieldOnBlur,
                                 ...field
                             },
                             fieldState: {error}
                         }) => (
                    <>
                        <Select
                            {...field}
                            {...props}
                            value={items.length !== 0 ? value : ''}
                            sx={sx}
                            onChange={(e, child) => {
                                if (onChange) onChange(e, child);
                                fieldOnChange(e);
                            }}
                            onBlur={(e) => {
                                if (onBlur) onBlur(e);
                                fieldOnBlur();
                            }}
                        >
                            {items.map((el) => el)}
                        </Select>
                        {
                            error && (
                                <Typography
                                    fontSize={12}
                                    marginTop={0.5}
                                    color={'red'}
                                >
                                    {error.message}
                                </Typography>
                            )
                        }
                    </>
                )}
            />
        </FormControl>
    );
}